import { flow, toPairs, groupBy, map } from 'lodash/fp';

import getItemMeasurement from './getItemMeasurement';

function measureComparison(m1, m2) {
  return m1.measure > m2.measure;
}

export function createMaxDepthValue(minDepth, isDecentralized, measurements) {
  if (minDepth && minDepth.ItemMeasureValue) {
    const minDepthValue = minDepth.ItemMeasureValue;
    if (isDecentralized) {
      return measurements ? measurements.maxDepthDecentralized : 1350;
    } else if (minDepthValue >= 100 && minDepthValue <= 450) {
      return 450;
    } else if (minDepthValue >= 451 && minDepthValue <= 635) {
      return 635;
    } else if (minDepthValue >= 635 && minDepthValue <= 1250) {
      return measurements ? measurements.maxDepthCentralized : 1250;
    } else {
      return 0;
    }
  }
  return 0;
}

function addMaxDepthToItem(item, maxDepth, measurements) {
// this function creates/correctly defines Max. depth when no Max. depth property is defined/incorrectly defined in item data.
  const itemMeasure = item.ItemMeasureList.ItemMeasure;
  const minDepth = itemMeasure.find((measurement) => measurement.ItemMeasureTypeNameEn === 'Min. depth');
  const isDecentralizedExpression = itemMeasure.find((measurement) => measurement.ItemMeasureTypeNameEn === 'Area');
  const createdMaxDepthValue = createMaxDepthValue(minDepth, isDecentralizedExpression, measurements);

  if (typeof maxDepth === 'object' && isNaN(maxDepth.ItemMeasureValue)) {
    if (createdMaxDepthValue > 0) {
      console.error("max Depth property: ItemMeasureValue value defined incorrectly for expression:", item.ValidDesignText, "with itemNo:", item.ItemNo, "max. depth set to default value of: ", createdMaxDepthValue);
      let index = itemMeasure.findIndex((measure) => measure.ItemMeasureTypeNameEn === 'Max. depth');
      item.ItemMeasureList.ItemMeasure[index].ItemMeasureValue = createdMaxDepthValue;
      return item;
    } else{
      console.error("max. depth and min. depth not defined/not properly defined for expression:", item.ValidDesignText, "with itemNo:", item.ItemNo, " , no depth values can be set. Expression excluded");
      return item;
    }
  } else if (maxDepth === null || maxDepth === undefined) {
    if (createdMaxDepthValue > 0) {
      item.ItemMeasureList.ItemMeasure.push({
        ItemMeasureTypeNameEn: "Max. depth",
        ItemMeasureValue: createdMaxDepthValue,
        ItemMeasureValueUnit: 'mm',
      });
      console.error("max. depth not defined for expression:", item.ValidDesignText, "with itemNo:", item.ItemNo, "Adding max. depth object. Set depth value to default value of: ", createdMaxDepthValue);
      return item;
    } else {
      console.error("max. depth and min. depth not defined/not properly defined for expression:", item.ValidDesignText, "with itemNo:", item.ItemNo, " , no depth values can be set. Expression excluded");
      return item;
    }
  }
  return item;
}

export default function groupByMeasure(items, typeName, groupBydepths, measurements) {
  if (groupBydepths) {
    items = items.map((item) => {
      const maxDepth = item.ItemMeasureList.ItemMeasure.find((Obj) => Obj.ItemMeasureTypeNameEn === 'Max. depth');
      if (!maxDepth || isNaN(maxDepth.ItemMeasureValue)) {
        return addMaxDepthToItem(item, maxDepth, measurements);
      } else {
        return item;
      }
    });
  }

  return flow(groupBy((item) => getItemMeasurement(item, typeName)),
  toPairs,
  map(([measure, itemsWithSameMeasure]) => ({
    measure: Number(measure),
    items: itemsWithSameMeasure,
  })))(items).sort(measureComparison);
}

export function groupByMeasureCoverPanels(items, typeName) {
  return flow(groupBy((item) => getItemMeasurement(item, typeName)),
  toPairs,
  map(([measure, itemsWithSameMeasure]) => ({
    measure: Number(measure),
    items: itemsWithSameMeasure,
  })))(items).sort(measureComparison);
}
